import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CumulativeCampaignDetails } from './model';
import { RootState } from '../root/root-types';

export const HOME_KEY = 'homeData';

export interface HomeState {
  campaigns: CumulativeCampaignDetails[];
  isFirstTimeHome: boolean;
}

export const initialHomeState: HomeState = {
  campaigns: [],
  isFirstTimeHome: true,
};

export const homeSlice = createSlice({
  name: HOME_KEY,
  initialState: initialHomeState,
  reducers: {
    updateCampaigns(state, action: PayloadAction<CumulativeCampaignDetails[]>) {
      state.campaigns = action.payload;
    },
    updateIsFirstTimeHome(state, action: PayloadAction<boolean>) {
      state.isFirstTimeHome = action.payload;
    },
  },
});

export const homeReducer = homeSlice.reducer;

export const { updateCampaigns, updateIsFirstTimeHome } = homeSlice.actions;

export const getHomeSliceState = (rootState: RootState): HomeState =>
  rootState[HOME_KEY];

export const getCampaigns = createSelector(
  getHomeSliceState,
  (state) => state.campaigns
);

export const getIsFirstTimeHome = createSelector(
  getHomeSliceState,
  (state) => state.isFirstTimeHome
);
